const Wrapper = require('./wrapper');
const Recommendations = require('../../components/recommendations/desktop');

module.exports = Wrapper(Recommendations);
